// Google Analytics 4 Event Tracking via Data Attributes

export const initEventTracking = () => {

	if (typeof window.dataLayer === 'undefined') {
		console.warn('dataLayer not found - GA4 events will not be tracked')
		return
	}

	function trackFormSubmission(form) {
		const gaContainer = form.closest('[data-ga-event]')
		const eventCategory = gaContainer ? gaContainer.getAttribute('data-ga-category') : null
		const eventName = gaContainer ? gaContainer.getAttribute('data-ga-event') : null
		const eventLabel = gaContainer ? gaContainer.getAttribute('data-ga-label') : null

		// alert('form.id: ' + form.id)
		// alert('form.name: ' + form.name)
		// alert('eventCategory: ' + eventCategory)
		// alert('eventName: ' + eventName)
		// alert('eventLabel: ' + eventLabel)

		if (eventCategory && eventName) {
			window.dataLayer.push({
				event: eventName,
				event_category: eventCategory,
				event_label: eventLabel || '',
				form_id: form.id || '',
				form_name: form.name || '',
			})
		}
	}

	function trackClick(element) {
		const eventCategory = element.getAttribute('data-ga-category')
		const eventName = element.getAttribute('data-ga-event')
		const eventLabel = element.getAttribute('data-ga-label')

		console.log(eventCategory)
		console.log(eventName)
		console.log(eventLabel)

		if (eventCategory && eventName) {
			window.dataLayer.push({
				event: eventName,
				event_category: eventCategory,
				event_label: eventLabel || '',
				link_text: element.textContent.trim(),
				link_url: element.href || '',
			})
		}
	}

	function trackAiFameSubmission() {
		window.dataLayer.push({
			event: 'ai_fame_submission',
			event_category: 'engagement',
			event_label: 'ai_fame_submission',
		})

		console.log('ai fame submission tracked')
	}

	document.addEventListener('submit', function (e) {
		const form = e.target
		console.log(form.parentElement.parentElement)
		if (form.parentElement.parentElement.hasAttribute('data-ga-event')) {
			console.log('tracking form submission')
			console.log(form.parentElement.parentElement)
			trackFormSubmission(form)
		}
	})

	document.addEventListener('click', function (e) {
		const element = e.target.closest('[data-ga-event]')
		if (element && element.tagName !== 'FORM' && element.id !== 'form') {
			trackClick(element)
		}
	})

	window.addEventListener('blur', function () {
		const activeEl = document.activeElement
		if (activeEl && activeEl.tagName === 'IFRAME') {
			const trackableEl = activeEl.hasAttribute('data-ga-event')
				? activeEl
				: activeEl.closest('[data-ga-event]')
			if (trackableEl) {
				console.log('tracking iframe click')
				trackClick(trackableEl)
			}
		}
		window.focus()
	})

	window.addEventListener('message', (e) => {
		console.log(e.data.type)
		if (e.data.type === 'pg-calibrate:submit') {
			trackAiFameSubmission()
		}
	})

	console.log('GA4 event tracking initialized')
}

export default () => { }

/* ============================================
	 RECOMMENDED GA4 EVENT STRUCTURE
	 ============================================
	 
	 For consistency across your reports, use:
	 
	 FORMS:
	 - Category: "form_submission"
	 - Event: "[form_type]_submit"
	 - Label: Specific identifier (page, content title, etc)
	 
	 CLICKS:
	 - Category: "engagement" | "contact" | "navigation"
	 - Event: "[action]_click"
	 - Label: Location or specific identifier
	 
	 ============================================ */
